module.exports = __webpack_public_path__ + "static/media/tanning-glasses.1ef20e90.png";